import { Component, EventEmitter, Input, Output } from "@angular/core";
import { ErrorClass, PasswordValidationError } from "@models";
import { VerificationPinComponent } from "./verification-pin.component";
import { BpModalHasSave } from "@models/interfaces/bp-modal-has-save";
import { FiatTransaction } from "@models/transaction";
import { ApicallOption, ApicallService } from "@core-services/apicall.service";
import { TranslationService } from "@core-services/translation.service";
import { InfoService } from "@core-services/info.service";

@Component({
	selector: "payments-verify-sms-pin",
	templateUrl: "./verification-pin.component.html",
	standalone: false
})
export class VerificationPinSmsPaymentsComponent extends VerificationPinComponent implements BpModalHasSave {
	@Output()
	public passwordLocked: EventEmitter<boolean> = new EventEmitter();

	@Input()
	public voiceCallEnabled: boolean = false;

	public constructor(
		protected apicallService: ApicallService,
		protected translationService: TranslationService,
		protected infoService: InfoService
	) {
		super(apicallService, translationService, infoService);
	}

	// Override
	public inputSecurity: boolean = true; // Password look (code hidden with dots/asterisk)

	// Override
	public createPinRequest(type: string = "sms"): void {
		// Request a new PIN through POST (not the regular GET for verification pin)
		const url = "fiatwallet/" + this.offer.getFiatWalletId() + "/transaction/" + this.offer.getId() + "/confirm";
		const options = new ApicallOption(FiatTransaction, { type: type });

		this.apicallService.post(url, options).subscribe(
			() => {
				this.pinSentF.emit(true);
				this.offer.setTriedPin(true);
				this.infoService.setSuccess(this.translationService.translate("sms_code_was_sent"));
			},
			(error) => {
				if (error instanceof ErrorClass) {
					this.infoService.setError(error);
					if (error instanceof PasswordValidationError) {
						this.passwordLocked.emit();
					}
				} else {
					console.error(error);
				}
			}
		);
	}

	// Override
	public save(): void {
		if (!this.done) {
			return;
		}

		const a = new ApicallOption(FiatTransaction, this.verificationPin);
		const url = "fiatwallet/" + this.offer.getFiatWalletId() + "/transaction/" + this.offer.getId() + "/confirm";

		this.apiCallSendPin(url, a);
	}

	// Override

	protected apiCallSendErrorHandling(error: Error): void {
		if (error instanceof PasswordValidationError) {
			this.infoService.setError(error);
			this.passwordLocked.emit();
		} else {
			super.apiCallSendErrorHandling(error);
		}
	}

	protected apiCallSendPin(url: string, option: ApicallOption): void {
		// Sending the PIN through PUT (not the regular POST for verification pin)
		this.apicallService.put(url, option).subscribe(
			(ans) => {
				this.offer = ans[0];
				this.accept.emit(this.offer);
			},
			(err) => {
				this.apiCallSendErrorHandling(err);
			}
		);
	}
}
